import cn from "classnames"

import { useTranslation } from "@/hooks/useTranslation"
import { Heading } from "@/molecules/Heading"
import { PriorityIcon } from "@/pages/TriagePage/components/pages/AdrManagementPage/components/molecules/PriorityIcon"

import styles from "./PriorityLabel.module.scss"

import type { Priority } from "@/domain/adr"

export const PriorityLabel = (props: {
  priority: Priority
  reverse?: boolean
  className?: string
  level?: 6 | 7
}) => {
  const { priority, reverse, className, level = 6 } = props
  const { t: tManagement } = useTranslation("translation", {
    keyPrefix: "triage.adr.management"
  })

  return (
    <div className={cn(styles.container, reverse && styles.reverse, className)}>
      <div>
        <PriorityIcon priority={priority} />
        <Heading level={level} title={tManagement(priority)} />
      </div>
    </div>
  )
}
